import { Box, FlexBox, Radio, Text } from '@dixa/lib-shared-habla';
import { ReactNode } from 'react';

import styles from './elevioRadioItem.module.scss';

type Props = {
  isActive: boolean;
  label: string;
  description: string;
  children: ReactNode;
  onRadioChange: () => void;
};

/**
 * Radio control item used to configure elevio integration. When active shows
 * additional configuration options.
 */
export function ElevioRadioItem({
  isActive,
  label,
  description,
  children,
  onRadioChange,
}: Props): JSX.Element {
  const id = label.replace(/\s/g, '-').toLowerCase();

  return (
    <div>
      <FlexBox gap="100" alignItems="center">
        <Radio checked={isActive} id={id} onChange={onRadioChange} />
        <label htmlFor={id} className={styles.radioLabel}>
          {label}
        </label>
      </FlexBox>
      <Box margin="100 0 0 500">
        <Text.Paragraph>{description}</Text.Paragraph>
        {isActive && children}
      </Box>
    </div>
  );
}
